export enum TransferCategory {
  /** 營運商提單 */
  OperatorWithdraw = 20,
  /** 營運商存單 */
  OperatorDeposit = 21,
  /** 租賃能量單 */
  RentEnergy = 23,
  /** 商戶提單 */
  TenantWithdraw = 30,
  /** 商戶存單 */
  TenantDeposit = 31,
  /** 會員代付 */
  MemberWithdraw = 40,
  /** 會員代收 */
  MemberDeposit = 41,
  /** 手動扣分 */
  ManualDeduct = 90,
  /** 手動加分 */
  ManualAdd = 91,
}

/** 轉帳單狀態 */
export enum TransferStatus {
  /** 已作廢 */
  invalid = 0,
  /** 已建立|待審核 */
  created = 1,
  /** 已通過 */
  allowed = 2,
  /** 已拒絕 */
  refused = 3,
  /** 轉帳中 */
  transferring = 4,
  /** 已到帳 */
  arrived = 5,
  /** 已到帳且金額正確 */
  arrived_with_right_amount = 6,
  /** 已到帳但金額錯誤 */
  arrived_with_wrong_amount = 7,
  /** 已到帳但金額錯誤-已通過 */
  checked_and_allowed = 8,
  /** 已到帳但金額錯誤-已拒絕 */
  checked_and_refused = 9,
  /** 已逾期 */
  expired = 10,
  /** 已到帳但金額錯誤-不提示 */
  arrived_with_wrong_amount_and_muted = 11,
  /** 無法轉帳：打款錢包餘額不足 */
  dist_insufficient = 100,
  /** 無法轉帳：打款錢包已達日打款上限 */
  dist_daily_excessive = 101,
  /** 無法轉帳-打款錢包已達周打款上限 */
  dist_weekly_excessive = 102,
  /** 無法轉帳-打款錢包已達月打款上限 */
  dist_monthly_excessive = 103,
  /** 無法轉帳：收款錢包餘額不足 */
  recv_insufficient = 200,
  /** 無法轉帳：收款錢包已達日打款上限 */
  recv_daily_excessive = 201,
  /** 無法轉帳-收款錢包已達周打款上限 */
  recv_weekly_excessive = 202,
  /** 無法轉帳-收款錢包已達月打款上限 */
  recv_monthly_excessive = 203,
  /** 發生錯誤-不明原因 */
  errored_with_unknown_reason = 900,
  /** 發生錯誤-交易異常 */
  errored_with_transaction_failure = 901,
}

/** 轉帳單金額計算 */
export enum TransferCalcRound {
  /** 不處理 */
  unchanged = 0,
  /** 無條件進位至整數 */
  roundUpToInt = 10,
  /** 無條件進位至小數點第一位 */
  roundUpToDime = 11,
  /** 無條件進位至小數點第二位 */
  roundUpToCent = 12,
  /** 四捨五入至整數 */
  roundOffToInt = 50,
  /** 四捨五入至小數點第一位 */
  roundOffToDime = 51,
  /** 四捨五入至小數點第二位 */
  roundOffToCent = 52,
  /** 無條件捨去至整數 */
  roundDownToInt = 90,
  /** 無條件捨去至小數點第一位 */
  roundDownToDime = 91,
  /** 無條件捨去至小數點第二位 */
  roundDownToCent = 92,
}
